import { Link } from 'react-router-dom'
import type { ReactNode } from 'react'
import type { WorkflowStepKey } from './types'

export interface WorkflowHubStepBody {
  key: WorkflowStepKey
  body: ReactNode
}

/** Rich HTML bodies for ComplianceAuditHub — keyed to shared workflow steps. */
export const workflowHubStepBodies: WorkflowHubStepBody[] = [
  {
    key: 'master-terms',
    body: (
      <>
        Approve keywords and synonyms in <Link to="/master-terms">Master terms</Link> before importing them into
        family term-reference rows.
      </>
    ),
  },
  {
    key: 'compliance-setup',
    body: (
      <>
        In <Link to="/pim">Compliance setup</Link>: use the <strong>Family</strong> and{' '}
        <strong>Compared attributes</strong> tabs — families, drawers for data groups, importing from master terms,
        and compared attribute rows.
      </>
    ),
  },
  {
    key: 'products',
    body: (
      <>
        Maintain the Kingspan catalogue in <Link to="/products">products</Link> (codes, approvals, comparison scope).
      </>
    ),
  },
  {
    key: 'rule-packs',
    body: (
      <>
        Maintain approved <Link to="/rules">rule packs</Link> — they drive terminology and structured checks downstream.
      </>
    ),
  },
  {
    key: 'distributors-targets',
    body: (
      <>
        Record distributor sites under <Link to="/distributors">distributors</Link>, then line up product URLs via{' '}
        <Link to="/targets">targets</Link>.
      </>
    ),
  },
  {
    key: 'run-checks',
    body: (
      <>
        Trigger runs from <Link to="/run-checks">run checks</Link> and track progress under{' '}
        <Link to="/check-runs">jobs</Link>.
      </>
    ),
  },
  {
    key: 'findings-reports',
    body: (
      <>
        Inspect <Link to="/findings">findings</Link> value vs terminology gaps, share{' '}
        <Link to="/distributor-action-reports">distributor action reports</Link> where required.
      </>
    ),
  },
]

export function getHubBodyForStep(key: WorkflowStepKey): ReactNode | undefined {
  return workflowHubStepBodies.find((b) => b.key === key)?.body
}
